<template>
  <b-modal
    v-model="show"
    centered
    hide-footer
    hide-header
    :body-bg-variant="variant"
  >
    <center>
      <p>{{ text }}</p>
      <fingerprint-spinner
        :animation-duration="1500"
        :size="300"
        color="#293a93"
        v-if="showSpinner"
      />
      <b-button
        v-if="button"
        :variant=buttonVariant
        @click="hide"
      >{{ button }}</b-button>
    </center>
  </b-modal>
</template>

<script>
import { FingerprintSpinner } from 'epic-spinners';

export default {
  props: {
    show: {
      type: Boolean,
      required: true
    },
    text: {
      type: String,
      required: false,
      default: 'Loading...',
    },
    variant: {
      type: String,
      required: false,
      default: 'light',
    },
    redirect: {
      type: String,
      required: false,
      default: '',
    },
    button: {
      type: String,
      required: false,
      default: 'Close',
    },
    buttonVariant: {
      type: String,
      required: false,
      default: "primary"
    },
    showSpinner: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  components: { FingerprintSpinner },
  methods: {
    hide() {
      if (this.redirect !== '') {
        this.$router.push(this.redirect);
      } else {
        this.$emit('hide')
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/utility/LoadingModal.vue